import React from "react";

function DesignStartup() {
  return (
    <>
      {/* <div className="choose-us-style-two default-padding bg-gray blurry-shape-left-bottom">
        <div className="container">
          <div className="row">
            <div className="col-lg-8 offset-lg-2">
              <div className="site-heading">
                <h4 className="sub-title">Design Startup</h4>
                <h2 className="title split-text-right split-text-in-right">
                  Empower your business to reach new heights decisive.
                </h2>
              </div>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="row align-center">
            <div className="col-lg-6">
              <div className="choose-us-two-thumb">
                <img
                  src="https://validthemes.net/site-template/robok/assets/img/thumb/5.jpg"
                  alt="Image Not Found"
                />
              </div>
            </div>
            <div className="col-lg-6 pl-80 pl-md-15 pl-xs-10">
              <div className="choose-us-two-info">
                <p>
                  Artificial Intelligence refers to the development of computer
                  systems that can perform tasks that would typically require
                  human intelligence. It involves the creation of algorithms and
                  models that enable machines to learn, reason, perceive, and
                  make decisions. It involves the creation of algorithms. There
                  are generally two types of AI: Narrow or Weak AI, which is
                  designed to perform specific tasks.
                </p>
                <ul className="list-style-four">
                  <li>
                    <div className="icon">
                      <i className="fad fa-chart-pie" />
                    </div>
                    <div className="info">
                      <h4>Data Analytics</h4>
                      <p>
                        Data Analytics is the science of analyzing raw data to
                        find trends, answer questions, and draw conclusions.
                      </p>
                    </div>
                  </li>
                  <li>
                    <div className="icon">
                      <i className="fad fa-cogs" />
                    </div>
                    <div className="info">
                      <h4>Automation</h4>
                      <p>
                        An Automation AI startup is a company that leverages
                        Artificial Intelligence (AI) and Machine Learning.
                      </p>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div> */}
      <div
        className="about-style-three-area default-padding bg-gray bg-cover"
        style={{ background: "url(assets/img/shape/banner-16.html)" }}
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-6">
              <h4 className="sub-title">AI writing assistant</h4>
              <h2 className="title split-text-right split-text-in-right">
                We Offer Best Margin Trading Exchange Development Service
              </h2>
              <p>
                Xeer Technology offers the best margin trading crypto exchange
                development services, providing a secure and scalable platform
                that empowers traders to leverage their positions for higher
                returns. Our tailored solutions include advanced features such
                as real-time market data integration, customizable leverage
                options, and automated risk management systems to ensure a
                smooth trading experience.
              </p>
              <p>
                With a focus on high liquidity, seamless user interfaces, and
                adherence to industry regulations, Xeer Technology delivers a
                robust and reliable margin trading exchange that meets the
                demands of both novice and experienced traders.
              </p>
              <a className="btn btn-style-one" href="#">
                Know more
              </a>
            </div>
            <div className="col-lg-6">
              <div className="about-style-three-thumb">
                <img
                  className="fade-up-anim"
                  src="https://validthemes.net/site-template/robok/assets/img/illustration/dashboard-4.jpg"
                  alt="Image Not Found"
                />
                <img
                  className="fade-up-anim"
                  src="https://validthemes.net/site-template/robok/assets/img/illustration/1.gif"
                  alt="Image Not Found"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default DesignStartup;
